export default "__VITE_ASSET__CQg7YVt7__"